import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VerifyState } from './types';

const initialState: VerifyState = {
  loading: {
    verify: false,
    initVerify: true,
  },
  isVerify: null,
  error: null,
};

export const VerifySlice = createSlice({
  name: 'verify',
  initialState,
  reducers: {
    setIsVerifyLoading(
      state,
      action: PayloadAction<Partial<Record<keyof VerifyState['loading'], boolean>>>,
    ) {
      state.loading = { ...state.loading, ...action.payload };
    },
    setVerify(state, action) {
      state.isVerify = action.payload.isVerify;
    },
    setVerifyError(state, action: PayloadAction<Error>) {
      state.error = action.payload;
    },
  },
});

const { actions, reducer } = VerifySlice;
export default reducer;
export const { setIsVerifyLoading, setVerify, setVerifyError } = actions;
